module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA7UlEQVQ4T73VOw7CMAwG4N+pBCfgFjDBCWBibdRTdmaEDZaywS24AAxJkCuKQptnK9Exar7YSexQWZYXIpoJIfZ1XT8w4quqaqG1PgB4kpTyCmAN4CaE2OWijCmlTkS0NMY0ZA/koq65xBl+Qj4CWKWivjktmIuGAviCqWgsmx8whsYwnj8AfSiPa62j++wE+6gx5k5EJuXQvKAjUh6K3tX/gfYBTE65jxVFsR19KC6sq+/saxPCXBXFW8HR2w3FWXquH+2uFlp40BxiWCzStn11FZCKhVBusA2ATS7m6VINg2cA86lPgFKKn4DXGwvQSUNySU6ZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/icon-back.png
// module id = 890
// module chunks = 0